import * as React from "react";

// import { useDispatch } from "react-redux";

import MuiButton from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ActionClose from "@material-ui/icons/Close";
// import ActionSubmit from "@material-ui/icons/Send";
// import ActionPrint from "@material-ui/icons/Print";
// import DownloadIcon from "mdi-material-ui/Download";

// import { showNotification } from "jazasoft";
import Table from "jazasoft/lib/mui/components/Table";

import { useDeepMemo } from "../../../hooks";
// import { BundleSheetType } from "../../../constants";
// import { DataType, getData, getHeader, printPieceTags, printTickets } from "../feedbackHelper";
import { DataType, getData, getHeader } from "../feedbackHelper";
// import { isEmpty } from "../../../utils/helpers";
// import SettingKeys from "../../../utils/SettingKeys";

const LayDialog = props => {
  const {
    open,
    // downloading,
    // order,
    // orderFlow,
    rollFields = [],
    lay,
    missingRolls,
    layRowList,
    onClose,
    // onRefresh,
    // reGenerateRemnantMarkers,
    // onPrint,
    // downloadBundles
  } = props;
  // const orderId = order?.id;

  // const [missingRows, setMissingRows] = React.useState([]);
  // const ticketSettingVal = useSetting(SettingKeys.TICKET_SETTING);
  // const ticketSetting = isEmpty(ticketSettingVal) ? {} : JSON.parse(ticketSettingVal);
  // const dispatch = useDispatch();
  // const [mutate, { loading: busy }] = useMutation();
  // const ticketPageFormat = useSetting(SettingKeys.TICKET_PAGE_FORMAT);
  // const enablePieceTag = useSetting(SettingKeys.ENABLE_BUNDLE_PIECE_TAG);
  // const pieceTagSettingVal = useSetting(SettingKeys.PIECE_TAG_SETTING);
  // const pieceTagSetting = isEmpty(pieceTagSettingVal) ? {} : JSON.parse(pieceTagSettingVal);

  // useDeepEffect(() => {
  //   setMissingRows(missingRolls);
  // }, [missingRolls]);

  // const onChange =
  //   ({ rowIdx }) =>
  //   event => {
  //     const value = event.target.checked;
  //     setMissingRows(missingRolls => {
  //       let newRows = [...missingRolls];
  //       const row = { ...newRows[rowIdx], found: value };
  //       newRows.splice(rowIdx, 1, row);
  //       return [...newRows];
  //     });
  //   };

  // const handleRegenerate = () => {
  //   const foundRolls = !isEmpty(missingRows) ? missingRows.filter(roll => roll.found) : [];
  //   reGenerateRemnantMarkers(foundRolls);
  // };

  // const onTicketPrint = ({ layNo }) => {
  //   if (isEmpty(order) || isEmpty(orderFlow)) return;

  //   const options = {
  //     url: `orders/${orderId}/bundles`,
  //     method: "get",
  //     params: { flowId: orderFlow.id, layNo }
  //   };
  //   mutate(options, {
  //     onSuccess: bundleSheet => {
  //       printTickets({ order, orderFlow, bundleSheet, layNo, format: ticketPageFormat, ticketSetting });
  //       onClose && onClose();
  //     }
  //   });
  // };

  // const onPieceTagPrint = ({ layNo }) => {
  //   if (isEmpty(order) || isEmpty(orderFlow)) return;

  //   const options = {
  //     url: `orders/${orderId}/bundles`,
  //     method: "get",
  //     params: { flowId: orderFlow.id, layNo }
  //   };
  //   mutate(options, {
  //     onSuccess: bundleSheet => {
  //       printPieceTags({ order, orderFlow, bundleSheet, layNo, pieceTagSetting });
  //       onClose && onClose();
  //     }
  //   });
  // };

  // const onBundleGenrate = () => {
  //   const options = {
  //     url: `orders/${orderId}/bundles`,
  //     method: "post",
  //     params: { flowId: orderFlow.id, layNo: lay.layNo }
  //   };
  //   mutate(options, {
  //     onSuccess: () => {
  //       dispatch(showNotification("Bundles generated successfully."));
  //       onRefresh && onRefresh();
  //       onClose && onClose();
  //     }
  //   });
  // };

  const { columns, rows, title } = useDeepMemo(() => {
    let columns, rows, title;
    if (lay) {
      title = `Lay #${lay.layNo}`;
      columns = getHeader({ dataType: DataType.LAY, rollFields });
      const finalLay = {
        ...lay,
        rowList: layRowList.filter(row => row.actualLayNo === lay.layNo)
      };
      rows = getData({ dataType: DataType.LAY, lay: finalLay });
    } else if (missingRolls && missingRolls.length > 0) {
      // title = "Missing Rolls";
      // columns = getHeader({ dataType: DataType.MISSING_ROLL });
      // columns[columns.length - 1].element = <CheckBox onChange={onChange} />;
      // rows = missingRolls.map((roll, idx) => ({ ...roll, serialNo: idx + 1 }));
    }
    return { columns, rows, title };
  }, [lay, layRowList, missingRolls, rollFields]);

  return (
    <Dialog id="dialog-container" fullWidth={true} maxWidth={lay ? "xl" : "md"} open={open} onClose={onClose}>
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <Divider />
      <DialogContent id="dialog-content" style={{ padding: 0 }}>
        <Table columns={columns} rows={rows} emptyMessage={lay && "Feedback for rolls not filled yet"} />
      </DialogContent>
      {(!rows || rows.length === 0) && <Divider />}
      <DialogActions id="dialog-actions" style={{ padding: "1em" }}>
        <MuiButton onClick={onClose} color={"primary"} variant="outlined">
          <ActionClose style={{ marginRight: 4 }} />
          Close
        </MuiButton>
        {/* {isTrue(enablePieceTag) && lay && lay.bundleGenerated && (
          <MuiButton onClick={() => onPieceTagPrint({ layNo: lay?.layNo })} color={"primary"} variant="outlined" disabled={busy}>
            <ActionPrint style={{ marginRight: 4 }} />
            Piece Tag
          </MuiButton>
        )}
        {lay && lay.bundleGenerated && (
          <MuiButton onClick={() => onTicketPrint({ layNo: lay?.layNo })} color={"primary"} variant="outlined" disabled={busy}>
            <ActionPrint style={{ marginRight: 4 }} />
            Bundle Tag
          </MuiButton>
        )} */}
        {/* {lay && lay.bundleGenerated && (
          <MuiButton onClick={() => onPrint({ layNo: lay?.layNo, type: BundleSheetType.NORMAL })} color="primary" variant="outlined" disabled={busy}>
            <ActionPrint style={{ marginRight: 4 }} />
            Bundle Plan
          </MuiButton>
        )}
        {lay && lay.bundleGenerated && (
          <MuiButton onClick={() => downloadBundles(lay?.layNo)} color="primary" variant="outlined" disabled={downloading}>
            <DownloadIcon style={{ marginRight: 4 }} />
            Download Bundles
          </MuiButton>
        )}
        {lay && lay.feedbackCompleted && !lay.bundleGenerated && (
          <MuiButton onClick={onBundleGenrate} color={"primary"} disabled={busy} variant="outlined">
            Generate Bundle Plan
          </MuiButton>
        )} */}
        {/* {!isEmpty(missingRolls) && (
          <MuiButton onClick={handleRegenerate} color={"primary"} disabled={busy} variant="outlined">
            <ActionSubmit style={{ marginRight: 4 }} />
            Submit
          </MuiButton>
        )} */}
      </DialogActions>
    </Dialog>
  );
};

export default LayDialog;
